import { faArrowRightToBracket } from '@fortawesome/pro-solid-svg-icons'
import AppHandoff from './AppHandoff'
import { mobileAppUrl } from './appHandoffModel'

export type Props = {
  token: string
}

const INVALID_LINK_MESSAGE = 'This sign-in link is not valid. Please request a new one from the app.'

const MagicLinkSignIn = ({ token }: Props) => <AppHandoff
  token={token}
  appUrl={token ? mobileAppUrl('magic-link', { token }) : null}
  invalidLinkMessage={INVALID_LINK_MESSAGE}
  prompt="Opening the SynkedUP app to finish signing you in. If it does not open on its own, tap the button below."
  alreadyOpenedPrompt="This link has already opened the SynkedUP app on this device. You can close this tab. If you still need to sign in, tap the button below."
  buttonLabel="Sign In"
  icon={faArrowRightToBracket}
/>

export default MagicLinkSignIn
